// External
import React, { useContext, useEffect, useState } from 'react';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import { gql, useMutation } from '@apollo/client';

// Internal
import useNotifier from '../hooks/useNotifier';
import { AuthContext } from '../context/AuthContext';
import Logo from '../assets/logos/CL-Logo-Transparent-260x60.png';
import RegisterForm from './Register/RegisterForm';

interface IProps {
  location: any;
}

type RegisterFormValues = {
  fullName: string;
  username: string;
  password: string;
  confirmPassword?: string;
};

interface LoginParams {
  accessToken?: string;
}

const Register: React.FC<IProps> = ({ location }) => {
  const history = useHistory();

  let { from } = location.state || { from: { pathname: '/overview' } };
  const { accessToken } = useParams<LoginParams>();
  const { login, isAuthenticated, getTokenMeta } = useContext(AuthContext);
  const [failedLogin, setFailedLogin] = useState<boolean>(false);
  const [failedRegister, setFailedRegister] = useState<boolean>(false);
  const [thePassword, setThePassword] = useState<string>('');
  const [theUsername, setTheUsername] = useState<string>('');
  const [success, setSuccess] = useState<boolean>(false);
  /**
   * Hooks
   */

  // Notification
  const notifier = useNotifier();

  const [authorize] = useMutation(REGISTER_AUTHORIZE_MUTATION, {
    errorPolicy: 'all',
    onCompleted: ({ authorize: authData }) => {
      if (!login(authData)) setFailedLogin(true);
      else setFailedLogin(false);
    },
    onError: (error) => setFailedLogin(true),
  });

  const [accountAdd, { called, loading }] = useMutation(
    REGISTER_ADDACCOUNT_MUTATION,
    {
      onCompleted: ({ accountAdd: accountData }) => {
        setSuccess(true);

        // if (accountData && loading) {
        //   notifier.showMessage(
        //     'Successfully saved!',
        //     'New account created.',
        //     'success'
        //   );
        //   authorize({
        //     variables: {
        //       username: theUsername,
        //       password: thePassword,
        //     },
        //   });
        // } else setFailedRegister(true);
      },

      onError: (error) => setFailedRegister(true),
    }
  );

  useEffect(() => {
    if (accessToken && login) {
      if (!login({ accessToken })) setFailedLogin(true);
    }
    if (getTokenMeta) {
      try {
        const meta = getTokenMeta();
        if (meta && meta.rurl) {
          history.push({
            pathname: '/overview',
          });
        }
      } catch (error) {}
    }
  }, [accessToken, login, getTokenMeta]);

  const onRegister = (values: RegisterFormValues) => {
    // Saving the data for auto-login once new account created.
    setThePassword(values.password);
    setTheUsername(values.username);

    // Filling the object with the RegisterForm returned values
    // in order to create the account via accountAdd.
    accountAdd({
      variables: {
        account: {
          users: [
            {
              username: values.username,
              person: {
                name: {
                  full: values.fullName,
                },
                email: values.username,
              },
            },
          ],
        },
      },
    });
  };

  // New account will always land on /overview
  //if (isAuthenticated) return <Redirect to="/overview" />;
  //else if (!failedRegister && failedLogin) return <Redirect to="/login" />;

  // Component
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <img
          className="mx-auto max-h-16 md:max-h-20 w-auto"
          src={Logo}
          alt="Logo"
        />

        <h2 className="mt-4 text-center text-lg md:text-xl font-extrabold text-gray-700">
          Register an account
        </h2>
      </div>

      <RegisterForm
        onRegister={onRegister}
        failedRegister={failedRegister}
        setFailedRegister={setFailedRegister}
        success={success}
      />
    </div>
  );
};

export default Register;

/**
 * TODO: Create/Move to /Register/Register.graph.ts (Maybe - R&D required for graph queries strategy)
 */

const REGISTER_AUTHORIZE_MUTATION = gql`
  mutation Register_AuthData($username: String!, $password: String!) {
    authorize(username: $username, password: $password) {
      accessToken
      tokenType
      expiresIn
    }
  }
`;

const REGISTER_ADDACCOUNT_MUTATION = gql`
  mutation Register_AddAccount($account: AccountInput!) {
    accountAdd(account: $account) {
      id

      roles
      users {
        id
        username

        person {
          name {
            full
          }
          email
        }
      }
    }
  }
`;
